import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const listarPlanos = async () => {
  const res = await axios.get(`${API_URL}/api/rotograma/planos`);
  return res.data;
};

export const listarRotasPlano = async (planoId: number) => {
  const res = await axios.get(`${API_URL}/api/rotograma/planos/${planoId}/rotas`);
  return res.data;
};

export const obterRotograma = async (rotaId: number) => {
  const res = await axios.get(`${API_URL}/api/rotograma/rotas/${rotaId}/rotograma`);
  return res.data;
};
